module.exports = __webpack_public_path__ + "img/emptyReports.b52d02ea.png";